import { render, staticRenderFns } from "./SlaPage.vue?vue&type=template&id=68d3e788&"
import script from "./SlaPage.vue?vue&type=script&lang=js&"
export * from "./SlaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d3e788')) {
      api.createRecord('68d3e788', component.options)
    } else {
      api.reload('68d3e788', component.options)
    }
    module.hot.accept("./SlaPage.vue?vue&type=template&id=68d3e788&", function () {
      api.rerender('68d3e788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/SlaPage.vue"
export default component.exports